// extracted by css-extract-rspack-plugin
export default {"inputs":"oOorzD","display-resolution":"zQwAiX","displayResolution":"zQwAiX"};